<template>
    <b-navbar :toggleable="false" variant="light">
      <div class="container">
        <b-navbar-brand href="/">Расписание</b-navbar-brand>
        <button v-if="!iss" type="button" class="btn btn-link nav-link semester-link" :class="{'d-none d-sm-inline-block': hasConflicts}" @click="$emit('select-semester',0)">{{ selectedSemester }} семестр</button>
        <b-collapse id="nav-collapse" is-nav class="nav-right">
          <b-navbar-nav class="ml-auto">
            <b-nav-item left @click="$emit('iss-click')" v-if="iss"><small>Обмен с ISS</small></b-nav-item>
            <b-nav-item left @click="$emit('conflicts-click')" v-if="hasConflicts" title="Конфликты расписания" aria-label="Конфликты расписания">
              <small>
                <span class="d-none d-sm-inline">Конфликты расписания </span>
                <span class="d-sm-none conflicts-alert-badge" aria-hidden="true">!</span>
                <b-badge variant="danger" pill>{{ conflictsCount }}</b-badge>
              </small>
            </b-nav-item>
            <b-nav-item-dropdown right v-if="!login" id="loginmenu">
              <template #button-content>Войти</template>
              <b-dropdown-form class="login-form">
                <b-dropdown-header id="dropdown-header-label">
                  <b-alert show variant="danger" v-if="loginErrorMessage" class="login-error"><div class="text-center">{{loginErrorMessage}}</div></b-alert>
                  <div v-else class="text-center">Авторизуйтесь и выберите<br>текущий семестр</div>
                </b-dropdown-header>
                <b-form-group label="Логин" label-for="dropdown-form-login" @submit.stop.prevent>
                  <b-form-input id="dropdown-form-login" size="sm" placeholder="usrxxxxx" autocomplete="username"></b-form-input>
                </b-form-group>
                <b-form-group label="Пароль" label-for="dropdown-form-password">
                  <b-form-input id="dropdown-form-password" type="password" size="sm" autocomplete="current-password"></b-form-input>
                </b-form-group>
                <b-form-group label="Семестр" label-for="dropdown-form-semester">
                  <b-button-group id="dropdown-form-semester" size="sm">
                    <b-button :pressed="selectedSemester==1" @click="$emit('select-semester',1)" variant="outline-primary">первый</b-button>
                    <b-button :pressed="selectedSemester==2" @click="$emit('select-semester',2)" variant="outline-primary">второй</b-button>
                  </b-button-group>
                </b-form-group>
                <b-form-checkbox class="mb-3 login-remember" :checked="remember" @input="val=>{$emit('input', val)}"> - запомнить меня</b-form-checkbox>
                <b-button variant="primary" size="sm" @click="$emit('save-settings')" block>Войти</b-button>
              </b-dropdown-form>
            </b-nav-item-dropdown>
            <b-nav-item-dropdown right v-else>
              <template #button-content>{{login}}</template>
              <b-dropdown-item-button @click="$emit('select-semester',0)">Семестр в ISS: {{ selectedSemester }} (сменить)</b-dropdown-item-button>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item-button @click="$emit('get-iss-works')">Выполнение нагрузки</b-dropdown-item-button>
              <!-- Аудит кафедры — отдельное приложение iss-audit-local
              <b-dropdown-item-button @click="$emit('dept-audit')">Аудит кафедры</b-dropdown-item-button>
              -->
              <b-dropdown-item-button @click="$emit('add-self-lesson')">Добавить занятия</b-dropdown-item-button>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item href="https://iss.vyatsu.ru/kaf">Кабинет кафедры</b-dropdown-item>
              <b-dropdown-item href="https://new.vyatsu.ru/account/obr/rasp/?login=yes">Расписание преподавателя</b-dropdown-item>
              <b-dropdown-item href="mailto:usr11935@vyatsu.ru">Связь с разработчиком</b-dropdown-item>
              <b-dropdown-item href="/Timetable.apk">Android приложение</b-dropdown-item>
              <b-dropdown-item-button @click="$emit('get-api-token')">Получить API token</b-dropdown-item-button>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-header class="cleanup-header">Очистить данные</b-dropdown-header>
              <b-dropdown-item-button @click="$emit('clear-auth')">Очистить авторизации</b-dropdown-item-button>
              <b-dropdown-item-button @click="$emit('clear-lessons')">Очистить занятия</b-dropdown-item-button>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item-button @click="$emit('logout')">Выйти</b-dropdown-item-button>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
</template>

<script>
export default {
  name: 'myNavBar',
  props: {
    login: String,
    remember: Boolean,
    iss: Boolean,
    showCopies: Boolean,
    loginErrorMessage: String,
    selectedSemester: Number,
    conflictsCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasConflicts() {
      return !!(this.login && this.conflictsCount > 0)
    }
  }
}
</script>

<style>
  .navbar {
    margin: 0px 0px 16px!important;
    position: fixed!important;
    top: 0px!important;
    left: 0px!important;
    width: 100%!important;
    z-index: 1000!important;
    backdrop-filter: blur(1rem)!important;
    box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 5%), inset 0 -1px 0 rgb(0 0 0 / 15%)!important;
    background-color: var(--navbar-bg)!important;
  }
  .dropdown-menu-right {
    right: 0;
  }
  .nav-right {
    justify-content: flex-end;
  }
  .semester-link {
    padding: 0.5rem 1rem;
    color: inherit;
    text-decoration: none;
  }
  .login-form {
    min-width: 280px;
  }
  .login-error {
    margin-bottom: 0;
    padding: 10px;
  }
  .login-remember {
    margin-top: 6px;
  }
  .conflicts-alert-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 2px;
    border-radius: 50%;
    background: var(--danger);
    color: #fff;
    font-weight: 700;
    font-size: .85rem;
    line-height: 1;
    vertical-align: middle;
  }
</style>
